import { serviceDirectoryApiClient } from '@/services/service-directory';

class Summary {
  fetchSummaries = async (
    region: string,
    country: string,
    entityTypes: string,
    complianceGroups: string,
    apiCategories: string,
    appFeatures: string,
    includeCountries?: boolean,
    features?: string
  ) => {
    const response = await serviceDirectoryApiClient.get(`entity-summaries`, {
      params: {
        region,
        country,
        entityTypes,
        complianceGroups,
        includeCountries,
        apiCategories,
        appFeatures,
        features,
      },
    });
    return response.data;
  };
}

export const SummaryInstance = new Summary();
